import { gql } from "@apollo/client"

export const GET_SHIFT_QUERY = gql`
    query Shift($id: MongoID!) {
        shift(_id: $id) {
            _id
            jobs {
                jobId
                grouping {
                    type
                    groupId
                }
            }
            vehicle {
                _id
            }
            shiftTemplateId
            shiftTemplateName
            shiftStart
            shiftEnd
            shiftHistory {
                status
                timestamp
            }
        }
    }
`
